import type { TPublisherRequest, TEnumItem } from '@modules/types'
import { formatApiDate, getEnumNameById } from '@modules/api-core'

const formatDate = (dateString: string | null | undefined): string => {
  if (!dateString) return 'N/A'
  return formatApiDate(dateString)
}

export type TFormattedRequestData = {
  statusLabel: string
  requestTypeName: string
  statusName: string
  songsCount: number
  licensee: string
  publicationAuthorArrangerEditor: string
  publicationType: string
  createdDate: string
  plannedPublicationDate: string
  additionalComments: string
  filesCount: number
  publisher: string
  distributionMethod: string
  distributionTerritory: string
  isReprint: boolean
  componentsCount: number
  totalRetailPrice?: string
  totalLicensedSongs: number
}

export const formatRequestData = (
  request: TPublisherRequest,
  enums: TEnumItem[],
  enumsLoading: boolean,
): TFormattedRequestData => {
  const {
    clientRequest: {
      statusId,
      cartItemTypeId,
      distributionMethod: distributionMethodId,
      licenseeName,
      publicationAuthorArrangerEditor,
      publicationType,
      plannedPublicationDate,
      additionalComments,
      files,
      publisherName,
      distributionTerritory,
      isReprint,
      distributionDetails,
    },
    songs,
    createdAt,
  } = request

  const statusName = enumsLoading
    ? 'Loading...'
    : getEnumNameById(enums, 'request_status_enum', statusId)
  const requestTypeName = enumsLoading
    ? 'Loading...'
    : getEnumNameById(enums, 'cart_item_type', cartItemTypeId)
  const distributionMethodName = enumsLoading
    ? 'Loading...'
    : getEnumNameById(enums, 'request_distribution_method_enum', distributionMethodId ?? 0)

  const firstLine = distributionDetails?.[0]

  return {
    statusLabel: statusName,
    requestTypeName: requestTypeName || 'N/A',
    statusName: statusName || 'N/A',
    songsCount: songs ? songs.length : 0,
    licensee: licenseeName || 'N/A',
    publicationAuthorArrangerEditor: publicationAuthorArrangerEditor || 'N/A',
    publicationType: publicationType || 'N/A',
    createdDate: formatDate(createdAt),
    plannedPublicationDate,
    additionalComments: additionalComments || '',
    filesCount: files ? files.length : 0,
    publisher: publisherName || 'N/A',
    distributionMethod: distributionMethodName || 'N/A',
    distributionTerritory: String(distributionTerritory || 'N/A'),
    isReprint: Boolean(isReprint),
    componentsCount: distributionDetails ? distributionDetails.length : 0,
    totalRetailPrice: firstLine?.retailPrice == null ? undefined : String(firstLine.retailPrice),
    totalLicensedSongs: firstLine?.numberOfCopyrightedWorks || 0,
  }
}
